import React from "react";
import PropTypes from "prop-types";
/**
 * Title: To display the title of DesignSection NodeGroup
 */
export function Title({ title }) {
  return <h3 className="nodeGroup_title">{title}</h3>;
}

Title.propTypes = {
  /**
   * Title for NodeGroup
   */
  title: PropTypes.string.isRequired,
};

Title.defaultProps = {
  title: "",
};
